import React from 'react'
import { timeResponseRow } from '../../../../../../helpers/table'

const MedianResponseTimeCell = ({ record }) => timeResponseRow(record.median_response_time)

const medianResponseTimeCellRenderer = (text, record) => <MedianResponseTimeCell record={record} />

export default medianResponseTimeCellRenderer
